var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[(_vm.$store.get('enrollment/selected@id') == 0)?[_c('v-col',{attrs:{"cols":"12"}},[_c('a',{attrs:{"href":"https://instagram.com/denticulus.id","target":"_blank"}})])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }